/**
 * Renders non-reversal line items that are not listed in the
 * `LINE_ITEMS` array in util/types.js
 *
 * The line items are rendered so that the line item code is formatted to human
 * readable form and the line total is printed as price.
 *
 * If you require another kind of presentation for your line items, add them to
 * the `LINE_ITEMS` array in util/types.js and create a specific line item
 * component for them that can be used in the `OrderBreakdown` component.
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CAMPING_PER_BOOKING_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemCampingPerBookingFeeMaybe = props => {
  const { lineItems, isProvider, intl, campingFeePerDayPerPerson } = props;

  // resolve unknown non-reversal line items
  const allItems = lineItems.filter(
    item => LINE_ITEM_CAMPING_PER_BOOKING_FEE === item.code && !item.reversal
  );

  const items = isProvider
    ? allItems.filter(item => item.includeFor.includes('provider'))
    : allItems.filter(item => item.includeFor.includes('customer'));

  return items.length > 0 ? (
    <React.Fragment>
      {items.map((item, i) => {
        const nights = item.units ?? 0;
        const seats = item.seats ?? 0;

        const seatLabel =
          (seats && campingFeePerDayPerPerson && campingFeePerDayPerPerson === 'perPerson') ??
          'perDay';

        const label = `Camping ${seatLabel ? `x ${seats}` : ''} ${
          seatLabel ? (seats > 1 ? 'Guests' : 'Guest') : ''
        } x ${nights} ${nights > 1 ? 'Nights' : 'Night'}`;

        const formattedTotal = formatMoney(intl, item.lineTotal);
        return (
          <div key={`${i}-item.code`} className={css.lineItem}>
            <span className={css.itemLabel}>{label}</span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  ) : null;
};

LineItemCampingPerBookingFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemCampingPerBookingFeeMaybe;
